import { render, staticRenderFns } from "./changeNickname.vue?vue&type=template&id=389b4545&scoped=true&"
import script from "./changeNickname.vue?vue&type=script&lang=ts&"
export * from "./changeNickname.vue?vue&type=script&lang=ts&"
import style0 from "./changeNickname.vue?vue&type=style&index=0&id=389b4545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b4545",
  null
  
)

export default component.exports